<template>
  <v-app class="custom__bg mt-1">
    <v-container>
      <v-row>
        <v-col cols="12" md="3">
          <SideCard />
        </v-col>
        <v-col cols="12" md="9" class="py-0 ">
          <v-card>
            <v-card flat>
              <v-card-text>
                <v-card class="custom__card">
                  <v-tabs
                    v-model="tab"
                    background-color="#f69227"
                    centered
                    hide-slider
                    color="#FFFFFF"
                    dark
                    height="35"
                    class="px-2 py-2"
                    grow
                    active-class="custom__tab"
                  >
                    <v-tab href="#classAlbum">
                      Class Album
                    </v-tab>

                    <v-tab href="#teacher">
                      Teacher
                    </v-tab>

                    <v-tab href="#classForum">
                      Class Forum
                    </v-tab>
                  </v-tabs>
                </v-card>
              </v-card-text>
            </v-card>
            <v-tabs-items v-model="tab">
              <v-tab-item value="classAlbum" id="classAlbum">
                <ClassAlbum />
              </v-tab-item>
              <v-tab-item value="teacher" id="teacher">
                <Teacher />
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import Teacher from "../components/teacher";
import ClassAlbum from "../components/classAlbum";
import SideCard from "../components/yearbook_card";
export default {
  components: {
    SideCard,
    ClassAlbum,
    Teacher,
  },
  data: () => ({
    tab: null,
  }),
};
</script>
<style scoped>
.custom__bg {
  background: #f5f5f5;
}
.custom__card {
  border-radius: 38px;

  box-shadow: 0 5px 16px 0 rgba(246, 146, 39, 0.35);

  background-color: #f69227;
}
.custom__tab {
  border-radius: 30px;
  background-color: #ffffff;
  color: #f69227;
}
</style>
